class InstagramFeed extends HTMLElement {
    constructor() {
        super();
        this.urlInst = this.dataset.instagram;
        this.url = 'https://instafeed.nfcube.com/feed/v6?limit=12&account=cgk-unlimited.myshopify.com&fu=0&fid=0&hash=188f6ba4cfb31cb3e0addf7f7500c728&locale=en';
        this.RenderElement();
    }

    async RenderElement () {
        await fetch(this.url, 
        {
            method: "POST",
        }).then( res => res.json()).then((res) => {
            const post = res.data;
            this.createElements(post);
        }) 
    }

    createElements (elements) {
        elements.forEach( (el, i) => {
            const url = el.link;
            const id = url.split("/reel/")[1]?.split("/")[0] || url.split("/p/")[1]?.split("/")[0];
            const { url: url_img } = el.images.standard_resolution;
            const swiperSlide = document.createElement('div');
            swiperSlide.classList.add('swiper-slide');
            const linkInstagram = document.createElement('a');
            linkInstagram.setAttribute('target','_blank');
            linkInstagram.href = `https://www.instagram.com/cgklinens/p/${id}`;
            const swiperSlideWrap = document.createElement('div');
            swiperSlideWrap.classList.add('swiper-slide__wrap');
            const imageDiv = document.createElement('div');
            imageDiv.classList.add('image');
            const imageWrap = document.createElement('div');
            imageWrap.classList.add('image__wrap');
            const imgElement = document.createElement('img');
            imgElement.src = url_img;
            imageWrap.appendChild(imgElement);
            imageWrap.appendChild(linkInstagram);
            imageDiv.appendChild(imageWrap);
            swiperSlideWrap.appendChild(imageDiv);
            swiperSlide.appendChild(swiperSlideWrap);

            this.querySelector('.swiper-wrapper').appendChild(swiperSlide);
        });
    }
}

customElements.define('instagram-feed', InstagramFeed);